import React, { FC } from 'react';
import { observer } from 'mobx-react';

import { DesktopWidget as BaseDesktopWidget } from '@servicetitan/marketing-integration-widgets/dist/text2chat/components/desktop-widget';
import { useDependencies } from '@servicetitan/react-ioc';

import { MESSAGE_MAX_LENGTH, NAME_MAX_LENGTH, WidgetStore } from '../../stores/widget.store';

import * as AnimationStyles from '../../styles/animations.module.less';

export const DesktopWidget: FC = observer(() => {
    const [
        {
            submitButtonDisabled,
            isSubmitting,
            handleSubmit,
            closeWidget,
            isSubmitted,
            widgetData,
            formState,
        },
    ] = useDependencies(WidgetStore);

    const {
        $: { name, phoneNumber, message },
    } = formState;

    if (!widgetData) {
        return null;
    }

    const {
        textBubble1ColorMask,
        textBubble2ColorMask,
        backgroundColorMask,
        buttonColorMask,
        headerColorMask,
        cardColorMask,
    } = widgetData.designSettings;

    const widgetProps = {
        message: {
            onChange: (event: any) => message.onChange(event.target.value),
            maxLength: MESSAGE_MAX_LENGTH,
            value: message.value,
            error: message.error,
        },
        name: {
            onChange: name.onChangeNativeHandler,
            maxLength: NAME_MAX_LENGTH,
            value: name.value,
            error: name.error,
        },
        phone: {
            onChange: phoneNumber.onChangeNativeHandler,
            value: phoneNumber.value,
            error: phoneNumber.error,
        },
        greetingMessage: widgetData.welcomeMessage,
        confirmationMessage: widgetData.confirmationMessage,
        textBubble2Color: textBubble2ColorMask,
        textBubble1Color: textBubble1ColorMask,
        contactNumber: widgetData.phoneNumber,
        className: AnimationStyles.fadeInItem,
        backgroundColor: backgroundColorMask,
        notAvailable: !widgetData.isEnabled,
        buttonColor: buttonColorMask,
        headerColor: headerColorMask,
        cardColor: cardColorMask,
        isSending: isSubmitting,
        submitButtonDisabled,
        isViewMode: false,
        handleSubmit,
        closeWidget,
        isSubmitted,
    };

    return <BaseDesktopWidget {...widgetProps} />;
});
